import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { Jobsite } from './types';
import {
  getCustomFieldsDefaultValues,
  getCustomFieldsSectionInputs,
  getCustomFieldsSectionUpdateInput,
} from './customFieldsSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'customFields'
>;

type GetFormInputsArgs = {
  jobsite: Jobsite;
};
export const getFormInputs = (
  args: GetFormInputsArgs,
): TypedFormInputs<EditJobsiteConfigTabFormData> => {
  const { jobsite } = args;

  return {
    customFields: {
      element: FormInputTypes.Section,
      layout: '',
      elementProps: {
        title: 'Custom Fields',
      },
      children: getCustomFieldsSectionInputs(jobsite),
    },
  };
};

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
};

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite } = args;
  const customFields = getCustomFieldsDefaultValues(jobsite);
  return { customFields };
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    ...getCustomFieldsSectionUpdateInput(
      data.customFields,
      dirtyFields.customFields,
    ),
  });
};
